import { render, staticRenderFns } from "./OrientationVideo.vue?vue&type=template&id=1241b8f3&scoped=true"
import script from "./OrientationVideo.vue?vue&type=script&lang=js"
export * from "./OrientationVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1241b8f3",
  null
  
)

export default component.exports